import * as tslib_1 from "tslib";
import { Selector } from '@swim/recon';
import { ModelParam } from '@swim/ui';
import { HtmlModel } from '@swim/ui';
var PieceModel = (function (_super) {
    tslib_1.__extends(PieceModel, _super);
    function PieceModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieceModel.Params = HtmlModel.Params.concat([
        new ModelParam('proportion', Selector.get('proportion')),
        new ModelParam('placement', Selector.get('placement')),
    ]);
    return PieceModel;
}(HtmlModel));
export { PieceModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGllY2UtbW9kZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwaWVjZS1tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGFBQWEsQ0FBQztBQUNyQyxPQUFPLEVBQUMsVUFBVSxFQUFDLE1BQU0sVUFBVSxDQUFDO0FBQ3BDLE9BQU8sRUFBQyxTQUFTLEVBQUMsTUFBTSxVQUFVLENBQUM7QUFFbkM7SUFBZ0Msc0NBQVM7SUFBekM7O0lBS0EsQ0FBQztJQUppQixpQkFBTSxHQUFHLFNBQVMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQy9DLElBQUksVUFBVSxDQUFDLFlBQVksRUFBRSxRQUFRLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQyxDQUFDO1FBQ3hELElBQUksVUFBVSxDQUFDLFdBQVcsRUFBRSxRQUFRLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0tBQ3ZELENBQUMsQ0FBQztJQUNMLGlCQUFDO0NBQUEsQUFMRCxDQUFnQyxTQUFTLEdBS3hDO1NBTFksVUFBVSJ9